import React, { useMemo } from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { ModalEntryPoint } from '../shared/modal-entry-point';
import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint } from './userLimitDirectBuyModal.entrypoint';

const modalProps = { width: 968, height: 560 };

export function UserLimitDirectBuyModal(): React.JSX.Element {
	const { cloudId } = useEditionAwareness();
	const entryPointParams = useMemo(() => ({ cloudId }), [cloudId]);

	return (
		<ModalEntryPoint
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			modalProps={modalProps}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
